import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { SyncActions } from '../actions/sync.actions';
import { SyncService } from '../services/sync.service';
import { TasksOverviewActions } from '../actions/tasks.actions';
import { GetTasksOfProjectDto } from '../dtos/getTasksOfProjectDto';
import { AumicoCoreProvider, NotificationType } from '../../../../aumico-lib-core-fe/src/lib';
import { WorkflowArea } from '../enums/workflow-area.enum';

@Injectable()
export class SyncEffects {
    constructor(
        private actions$: Actions,
        private syncService: SyncService,
        private coreProvider: AumicoCoreProvider,
    ) {}
    syncProjectWorkflow$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SyncActions.syncProjectWorkflow),
            switchMap(({ projectId, workflowArea, sync, subjectType }) =>
                this.syncService.syncProjectWorkflow(projectId, workflowArea, sync, subjectType).pipe(
                    tap(() => {
                        this.coreProvider.dispatchAddNotification(
                            'aumico_cpmm_sync_success_title',
                            'aumico_cpmm_sync_success_description',
                            NotificationType.SUCCESS,
                        );
                    }),
                    switchMap((response: GetTasksOfProjectDto) => [
                        TasksOverviewActions.projectTasksLoaded({ response }),
                        SyncActions.projectWorkflowSynced({ response }),
                    ]),
                    catchError((error) => {
                        if (workflowArea === WorkflowArea.CLOSING_PROCESS) {
                            this.coreProvider.dispatchAddNotification(
                                'aumico_cpmm_sync_failure_title',
                                'aumico_cpmm_sync_failure_description',
                                NotificationType.ERROR,
                                4000,
                            );
                        } else {
                            this.coreProvider.dispatchAddNotification(
                                'aumico_cpmm_sync_failure_title',
                                NotificationType.ERROR,
                            );
                        }

                        return of(SyncActions.projectWorkflowSyncFailure({ error }));
                    }),
                ),
            ),
        ),
    );
}
